// extracted by mini-css-extract-plugin
export var columnList = "_gg-0";